// Компонент-менеджер попапов.
// Передает данные, необходимые для рендеринга, в компоненты попапов из popupsState.
// Открывает попап, id которого хранится в качестве активного в popupsState.openedPopupId.
// Навешивает функциональность открытия попапа на ссылки в документе с классом ".js-show-popup"

import { computed } from "vue";
import signinPopup from "./components/signin-popup";
import signupPopup from "./components/signup-popup";
import resetPasswordPopup from "./components/reset-password-popup";
import errorPopup from "./components/error-popup";
import messagePopup from "./components/message-popup";
import signupPaymentPopup from "./components/signup-payment-popup";
import welcomePopup from "./components/welcome-popup/index";

import popupsState from "./popups-state";
import dom from "../dom";

const template = /* html */`
    <div>

        <errorPopup
            :isActive="openedPopupId == 'error_popup'"
            :errors="errorPopupData"
            @closedPopup="dispatchClose()"
        />
        <messagePopup
            :isActive="openedPopupId == 'message_popup'"
            :message="messagePopupData.message"
            :details="messagePopupData.details"
            :onClose="messagePopupData.onClose"
            @closedPopup="dispatchClose()"
        />
        <welcomePopup v-if="!openedPopupId" :shouldWelcome="shouldWelcome"/>

        <template v-if="!isAuthentificated">
            <signinPopup
                :isActive="openedPopupId == 'authorization_popup'"
                :nextPage="nextPage"
                :csrfToken="csrfToken"
                :email="email"
                @emailChanged="email = $event"
                @closedPopup="dispatchClose()"
            />
            <signupPopup
                :isActive="openedPopupId == 'registration_popup'"
                :nextPage="nextPage"
                :csrfToken="csrfToken"
                :captchaKey="captchaKey"
                :signupSource="signupSource"
                :email="email"
                @emailChanged="email = $event"
                @closedPopup="dispatchClose()"
            />
            <resetPasswordPopup
                :isActive="openedPopupId == 'password_reset_popup'"
                :csrfToken="csrfToken"
                :captchaKey="captchaKey"
                :email="email"
                @emailChanged="email = $event"
                @closedPopup="dispatchClose()"
            />
            <signupPaymentPopup
                :isActive="openedPopupId == 'signup_payment_popup'"
                :csrfToken="csrfToken"
                :captchaKey="captchaKey"
                :email="email"
                :amount="signupPaymentPopupData.amount"
                :planName="signupPaymentPopupData.planName"
                :quantity="signupPaymentPopupData.quantity"
                @openSigninPopup="dispatchOpen({newPopupId: 'authorization_popup'})"
                @emailChanged="email = $event"
                @closedPopup="dispatchClose()"
            />
        </template>
    </div>
`;

export default {
    setup() {
        const {
            user,
            settings,
        } = window.DA;

        const {
            errorPopupData,
            messagePopupData,
            signupPaymentPopupData,
            openedPopupId,
            dispatchOpen,
            dispatchClose,
        } = popupsState;

        const isAuthentificated = user.isAuthenticated;
        const csrfToken = settings.CSRF_TOKEN;
        let nextPage = window.location.pathname;

        const next = dom.locationParams.get("next");
        if (next) {
            nextPage = next + window.location.hash;
        }

        return {
            isAuthentificated,
            csrfToken,
            nextPage,
            errorPopupData,
            messagePopupData,
            signupPaymentPopupData,
            openedPopupId,
            dispatchClose,
            dispatchOpen,
        };
    },
    data() {
        return {
            captchaKey: "",
            email: "",
            signupSource: "UNKNOWN",
            shouldWelcome: false,
            userecho: "",
        };
    },
    mounted() {
        this.captchaKey = this.$el.parentNode.dataset.captchaKey;
        this.userecho = this.$el.parentNode.dataset.userecho || this.userecho;
        this.shouldWelcome = this.$el.parentNode.dataset.welcome === "true";

        dom.callAfterWindowLoaded(() => {
            if (window.location.hash === "#registration_popup") {
                this.dispatchOpen({ newPopupId: "registration_popup" });
            } else if (
                window.location.hash === "#authorization_popup" ||
                dom.locationParams.has("authorization_popup")
            ) {
                this.dispatchOpen({ newPopupId: "authorization_popup" });
            }
            const popupLinks = document.querySelectorAll(".js-show-popup");
            popupLinks.forEach(link => link.addEventListener("click", this.handleLinkClicks));
            document.addEventListener("keyup", this.handleKeyUp);
        });
    },
    provide() {
        return { userecho: computed(() => this.userecho) };
    },
    template,
    methods: {
        handleLinkClicks(e) {
            if (!e.target.hash) return;
            e.preventDefault();
            if (e.target.dataset.source) {
                this.signupSource = e.target.dataset.source || "UNKNOWN";
            }
            this.dispatchOpen({ newPopupId: e.target.hash.slice(1) });
        },
        handleKeyUp(e) {
            if (e.keyCode !== 27 || !this.openedPopupId) return;
            this.dispatchClose();
        },
    },
    components: {
        signinPopup,
        signupPopup,
        resetPasswordPopup,
        errorPopup,
        messagePopup,
        signupPaymentPopup,
        welcomePopup,
    },
};
